/*========================================================================
 * $Id: dom.js 73289 2013-06-17 06:55:25Z michael.biebl $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(['underscore', 'mbmustache', 'utils/jsonpath', 'i18n/i18n'], function(_, Mustache, JSONPath, i18n) {
  var I18N_REGEXP = /i18n\./;

  function EscapedWriter(escapeFunction) {
    this.escapeFunction = escapeFunction;
    return Mustache.Writer.apply(this, Array.prototype.slice.call(arguments, 1));
  }

  if (Mustache.Writer && Mustache.Writer.prototype._escaped) {
    
    EscapedWriter.prototype = _.clone(Mustache.Writer.prototype);
    EscapedWriter.prototype.constructor = EscapedWriter;
    EscapedWriter.prototype._escaped = function(name, context) {
      if (!this.escapeFunction) {
        return Mustache.Writer.prototype._escaped.apply(this, arguments);
      }
      return this.escapeFunction(this._name(name, context));
    }
  }
  else {
    EscapedWriter = Mustache.Writer;
  }

  function MustacheTemplate(template, options) {
    this.template = template;
    var options = options || {};
    this.options = options;
  }

  _.extend(MustacheTemplate.prototype, {

    _format:function(token) {
      var format = null;
      switch (token[0]) {
      case '#':
        format = "PROPERTY";
        break;
      case 'name':
        format = "VALUE";
        break;
      case '&':
        format = "HTML";
        break;
      case '^':
        format = "PROPERTY";
        break;
      case 'text':
        // trace("HTML:", token[1]);
        break;
      default:
        // trace("** unknown ** ", JSON.stringify(token));
        break;
      }
      return format;
    },

/*
 [ '#',
  'mes:nested',
  0,
  15,
  [ [ 'text', '  fdsa ', 15, 22 ],
    [ '#', 'result', 22, 33, [Object] ],
    [ 'text', ' ', 56, 57 ] ] ]
*/

    addPropertiesFromTokens: function(tokens, properties) {

        for (var i = 0; i < tokens.length; ++i) {
          var token = tokens[i];
          // console.log(token);
          var isObject = token[0] == '#';
          var name = token[1];
          var isCondition = /\?$/.test(name);
          name = name.replace(/\?$/, "");
          var format = this._format(token);
          if (format == null) continue;
          var nestedProperties = null;
          if (isCondition) {
            this.addPropertiesFromTokens(token[4], properties);
            // tokens = tokens.concat(token[4]);
          }
          if (isObject) {
            nestedProperties = this.addPropertiesFromTokens(token[4], {});
          }

          if (properties[name]) {
            if (properties[name].format != format) {
              properties[name].format = "PROPERTY";
            }
          }
          else {
            properties[name] = {format: format};
          }
          if (nestedProperties != null) {
            var existing = properties[name].properties || {};
            properties[name].properties = _.extend(existing, nestedProperties);
          }
        }

        return properties;
    },
    
    getNestedProperties: function() {
      if (!this.tokens) {
        try {
          this.tokens = Mustache.parse(this.template);
        } catch (e) {
          if (console && console.warn) {
            console.warn("Failed to parse template ", this.template, e);
          }
          throw e;
        }
      }
      
      if (!this.nestedProperties) {        
        this.nestedProperties = this.addPropertiesFromTokens(this.tokens, {});
      }
      return this.nestedProperties;
      
    },
    
    getProperties: function () {
      if (!this.tokens) {
        try {
          this.tokens = Mustache.parse(this.template);
        } catch (e) {
          if (console && console.warn) {
            console.warn("Failed to parse template ", this.template, e);
          }
          throw e;
        }
      }

      if (!this.properties) {
        var properties = {};
        var tokens = [].concat(this.tokens);
        
        for (var i = 0; i < tokens.length; ++i) {
          var token = tokens[i];
          // console.log(token);
          var name = token[1];
          var isCondition = /\?$/.test(name);
          name = name.replace(/\?$/, "");
          var format = this._format(token);
          if (format == null) continue;
          
          if (isCondition) {
            tokens = tokens.concat(token[4]);
          }

          if (properties[name]) {
            if (properties[name].format != format) {
              properties[name].format = "PROPERTY";
            }
          }
          else {
            properties[name] = {format: format};
          }
        }
        this.properties = properties;
     }
     return this.properties;
    },

    _toString: function(object, name) {
      if (_.isArray(object)) {
       var that = this;
       var separator = ',';

       if (name && this.options && this.options.mustacheListSerializationRules) {
        var foundRSerializationRule = _.find(this.options.mustacheListSerializationRules, function(rule) {
            var regex = new RegExp(rule.namePattern);
            return regex.test(name);
        });
        if (foundRSerializationRule && foundRSerializationRule.separator) {
          separator = foundRSerializationRule.separator;
        }
       }
       return _.map(object, function(v) { return that._toString(v); }).join(separator);
      }
      if (_.isString(object)) {
        return object;
      }
      if (object != null)
        return JSON.stringify(object);
      return object;
    },


    renderTokens: function (existingTokens, model, valueModel, formatProvider, options, tokenPrefix) {
      var view = {};
      var tokens = [];
      for (var i = 0; i < existingTokens.length; ++i) {
        try {
        var token = existingTokens[i];

        var name = token[1];
        var format = this._format(token);

        if (format == null) {
          tokens.push(token); continue;
        }

        var genName = tokenPrefix + i;

        if (I18N_REGEXP.test(name)) {
          token[1] = name;
          var i18nKey = name.replace(I18N_REGEXP, "");
          view.i18n = view.i18n || {};
          view.i18n[i18nKey] = i18n(i18nKey);
          tokens.push(token);
        } else {
          var value;
          if (/\?$/.test(name)) {
            value = !!(model && model.get(name.replace(/\?$/, ""), {"format": format}));
            if (!value) value = null;
          } else {
            value = model && model.get(name, {"format": format});
          }
          // 
          if (format == "PROPERTY") {  // Object is required
            var that = this;


            var renderToken = function(name, token, genName, tokens, view) {
              var subModel,
                  disposeSubModel,
                  valueSubModel,
                  disposeValueSubModel;

              try {
                var subTokens = token[4];
                // console.log("name: ", name);        
                // console.log("model.get()[" + name + "]: ", model.get()[name]);
                // console.log(format);
                // console.log("model.get(" + name + "): ", model.get(name, {"format": format}));
                token = _.clone(token);
                var v;
                if (/\?$/.test(name)) {
                  // request property for ?
                  v = !!(model && model.get(name.replace(/\?$/, ""), {"format": "PROPERTY"} ));// "VALUE", "overridePropertyFormat": true));
                  if (!v) v = null;
                } else {
                  // console.log("model.get", name);
                  v = model && model.get(name, {"format":format});
                }
                if (token[0] == '^') {
                  if (v != null) {
                    return;
                  } else {
                    token[0] = '#';
                    subModel = model;
                    valueSubModel = model;
                  }
                } 
                else {
                  if (v == null) {
                    return;
                  } else {
                    if (_.isObject(v) || _.isArray(v)) {
                      // console.log("submodel: ",name, format);
                      // console.log("model: ", model.get());
                      subModel      = model && model.submodel(name, {"format": format});
                      disposeSubModel = true;
                      try {
                        valueSubModel = model && model.submodel(name, {"format": "VALUE"});
                        disposeValueSubModel = true;
                      } catch (e) {
                        valueSubModel = subModel;
                      }
                      // console.log("submodel: ", subModel.get());
                    }
                    else {
                      subModel = model;
                    }
                  }
                }
                var result = that.renderTokens(subTokens, subModel, valueSubModel, formatProvider, options, genName + "_");
                token[1] = genName;
                token[4] = result.tokens;
                // console.log("view[" + genName + "]", result.view);
                view[genName] = result.view
                tokens.push(token);
              } finally {
                if (disposeSubModel && subModel && subModel.dispose) {
                  subModel.dispose();
                }
                if (disposeValueSubModel && valueSubModel && valueSubModel.dispose) {
                  valueSubModel.dispose();
                }
              }
            }
            // end rendering

            // console.log("value", value);
            if (_.isArray(value)) {
              // console.log(JSON.stringify(value));
              for (var j = 0 ; j < value.length; ++j) {
                renderToken(name + "[" + j + "]", token, genName + "_" + j, tokens, view);
              }
            } else {
              renderToken(name, token, genName, tokens, view);
            } 
          }
          else {
            // console.log("name: ", name);        
            token = _.clone(token);
            function filterNulls(value) {
              if (_.isArray(value)) {
                var valueP = _.filter(_.flatten(value, false), function(v) { return v != null; });
                if (valueP.length == 0 && value.length > 0) return null;
                return valueP;
              }
              return value;
            }

            var value;
            var isTest = false;
            if (/\?$/.test(name)) {
              name = name.replace(/\?$/, "");
              isTest = true;
            }
            value = model && model.get(name, {"format": format});
            if (filterNulls(value) == null) {
              value = valueModel && valueModel.get(name, {"format": format});
            }

            if (isTest) {
              value = !!(value);
              if (!value) value = null;
            }

            // console.log("model.get(): ", model.get());
            // console.log("model.get(" + name + "): ", model.get(name));
            // console.log("valueModel.get(" + name + "): ", valueModel.get(name));
            if (format != "PROPERTY" && !_.isString(value)) {
              value = this.str(value, name);
            }

            token[1] = genName;
            view[genName] = value;
            tokens.push(token);
          }
        }

        } catch(e) {
          if (console && console.warn) {
            console.warn("Failed to render token.", e, e.stack);
          }
        }

      }
      return {view: view, tokens: tokens};
    },

    render: function (model, formatProvider, options) {
      if (!this.tokens) {
        try {
          this.tokens = Mustache.parse(this.template);
        }  catch (e) {
          if (console && console.warn) {
            console.warn("Failed to parse template ", this.template, e);
          }
          throw e;
        }
      }

      var options = options || {};
      this.str = options.str || _.bind(this._toString, this);

      var properties = this.getProperties();

      var result = this.renderTokens(this.tokens, model, model, formatProvider, options, "token_");
      // console.log(JSON.stringify(attributes, null, 1));
      return new EscapedWriter(this.options.escape).compileTokens(result.tokens, "" )(result.view, false);
    }

  });
  
  function escapeIdentity(string) {
    return string;
  }

  MustacheTemplate.noEscape = escapeIdentity;
  return MustacheTemplate;

});
